export default "__VITE_PUBLIC_ASSET__5e3733f0__"